<script lang="ts">

  import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "$lib/components/ui/dialog"
  import { ImageWithFallback } from "$lib/components/ui/image-with-fallback"
  import type { News } from "../_types"

  let { open = false, setOpen, select }: {
    open?: boolean
    setOpen: (value: boolean) => void
    select: News
  } = $props()

</script>

<Dialog
  open={open}
  onOpenChange={setOpen}>
  <DialogContent
    class="w-sm p-0"
    onOpenAutoFocus={(event) => event.preventDefault()}>
    <DialogHeader class="hidden">
      <DialogTitle>Detail</DialogTitle>
      <DialogDescription></DialogDescription>
    </DialogHeader>
    <div>
      <ImageWithFallback
        src={select.image_url}
        alt={select.name}
        class="h-60 rounded-b-none"
        onclick={() => select.image_url.fileOpen()}/>
      <div class="space-y-3 px-3 py-3">
        <div>
          <DialogTitle>{select.name}</DialogTitle>
          <div class="text-desc font-mono">
            {select.datetime ? select.datetime.toDateFormat("EEEE, dd MMMM yyyy") : "-"}
          </div>
        </div>
        <!-- eslint-disable-next-line svelte/no-at-html-tags -->
        <div>{@html select.content}</div>
        <div class="border-t pt-3 text-primary">{select.source || "-"}</div>
      </div>
    </div>
  </DialogContent>
</Dialog>
